export default __webpack_public_path__ + "static/media/Flag_of_Oman.78f78da2.svg";